import initialFeeCreditCardPayment from '../../../../api/deals/initialFeeCreditCardPayment';
import Button from '../../../../components/Button/Button';
import DownloadFileLink from '../../../../components/DownloadFileLink/DownloadFileLink';
import HookForm from '../../../../components/HookForm/HookForm';
import SelectDealPaymentStatuses from '../../../../components/Selects/selectDealPaymentStatuses';
import { DOCUMENT_TYPES_INVOICE, PAYMENT_STATUS_PAID } from '../../../../constants';
import alert from '../../../../helpers/alert';

const PaymentStatus = ({ documents, onSubmit, loading, backHandler, setLoading, bankId, chunkId }) => {
  const onPaymentSubmit = (values) => {
    if (values?.status?.value != PAYMENT_STATUS_PAID) return;

    onSubmit(values);
  };

  const sendPaymentSms = () => {
    setLoading(true);
    initialFeeCreditCardPayment({
      bankId: bankId,
      chunkId: chunkId,
    })
      .then(() => {
        alert.success('Ð¡Ð¼Ñ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð½Ð° Ð¾Ð¿Ð»Ð°ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð½Ð° Ð½Ð¾Ð¼ÐµÑ ÑÐµÐ»ÐµÑÐ¾Ð½Ð° ÐºÐ»Ð¸ÐµÐ½ÑÐ°');
      })
      .catch((err) => {
        alert.error(err?.response?.data?.message || 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð¾ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ ÑÐ¼Ñ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð½Ð° Ð¾Ð¿Ð»Ð°ÑÑ');
      })
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <HookForm
        title={'Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ'}
        grid={{ display: 'grid', gap: 20 }}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        inputs={[
          {
            name: 'status',
            component: SelectDealPaymentStatuses,
          },
        ]}
        customDataTop={() => (
          <div>
            {documents
              ?.filter((item) => item?.typeId === DOCUMENT_TYPES_INVOICE)
              .map((document) => (
                <DownloadFileLink document={document} />
              ))}
          </div>
        )}
        customData={() => (
          <Button text="ÐÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð¡ÐÐ¡ ÑÐ¾ ÑÑÑÐ»ÐºÐ¾Ð¹ Ð½Ð° Ð¾Ð¿Ð»Ð°ÑÑ Ð¿ÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½Ð¾Ð³Ð¾ Ð²Ð·Ð½Ð¾ÑÐ°" fill onClick={sendPaymentSms} />
        )}
        onSubmit={onPaymentSubmit}
        submitButtonFull
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default PaymentStatus;
